import axios from "../utils/axios";

export const getAllOrgStructureAssignments = async (page = 1, per_page = 15, filters = {}) => {
    const params = { ...filters };
    if (page) params.page = page;
    if (per_page) params.per_page = per_page;
    const { data } = await axios.get('/org-structure-assignments', { params });
    return data;
};

export const getOrgStructureAssignment = async (id) => {
    const { data } = await axios.get(`/org-structure-assignments/${id}`);
    return data;
};

export const createOrgStructureAssignment = async (req) => {
    const { data } = await axios.post('/org-structure-assignments', req, { headers: { Accept: 'application/json' } });
    return data;
};

export const updateOrgStructureAssignment = async (req, id) => {
    const { data } = await axios.put(`/org-structure-assignments/${id}`, req, { headers: { Accept: 'application/json' } });
    return data;
};

export const deleteOrgStructureAssignment = async (id) => {
    const { data } = await axios.delete(`/org-structure-assignments/${id}`, { headers: { Accept: 'application/json' } });
    return data;
};

export const deleteAllOrgStructureAssignments = async (req) => {
    const { data } = await axios.delete('/org-structure-assignments/mass-destroy', { data: req, headers: { Accept: 'application/json' } });
    return data;
};

export const bulkCreateOrgStructureAssignment = async (req) => {
    const { data } = await axios.post('/org-structure-assignments/bulk', req, { headers: { Accept: 'application/json' } });
    return data;
};

export const deactivateOrgStructureAssignment = async (id) => {
    const { data } = await axios.post(`/org-structure-assignments/${id}/deactivate`, {}, { headers: { Accept: 'application/json' } });
    return data;
};
